// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"5aa43bba","489":"efe9b4b1"}[chunkId] + ".chunk.js";
};